module.exports = __webpack_public_path__ + "static/img/2.924e741.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/main/2.jpg
// module id = 7o1+
// module chunks = 0